module.exports = __webpack_public_path__ + "static/media/temp_34.add1b7a1.jpg";